import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';

// Q&A card for the live-meeting PDF. Renders a single Q+A exchange with
// speaker labels — no scoring, no coaching, no covered/missed lists. Live-
// meeting Q&A is transcript context, not training.
//
// Practice-pitch Q&A has its own coaching-shaped renderer in
// NewAssessmentDetails.jsx — that flow is unchanged.
const QACard = ({ qa, index }) => {
  return (
    <View wrap={false} style={{
      backgroundColor: '#ffffff',
      borderRadius: 6,
      borderWidth: 0.6,
      borderColor: colors.hair,
      padding: space.lg,
      marginBottom: space.md,
    }}>
      <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
        <Text style={[type.cardTitle, { color: colors.teal, marginRight: space.sm }]}>
          Q{index + 1}{qa.questionSpeaker ? ` · ${qa.questionSpeaker}` : ''}
        </Text>
        <Text style={[type.cardTitle, { color: colors.ink, flex: 1 }]}>{qa.question}</Text>
      </View>

      <View style={{ marginTop: space.md, flexDirection: 'row', alignItems: 'flex-start' }}>
        <Text style={[type.cardTitle, { color: colors.teal, marginRight: space.sm }]}>
          A{qa.answerSpeaker ? ` · ${qa.answerSpeaker}` : ''}
        </Text>
        {qa.answer ? (
          <Text style={[type.body, { color: colors.inkSoft, flex: 1 }]}>{qa.answer}</Text>
        ) : (
          <Text style={[type.body, { color: colors.muted, fontStyle: 'italic', flex: 1 }]}>
            (no substantive response captured)
          </Text>
        )}
      </View>
    </View>
  );
};

export default QACard;
